import { all, fork, spawn } from 'redux-saga/effects';
import { watchAllocationBulkActionSaga, watchUpdateAllocatedMemberSaga } from './allocation';
import { watchAllAutomationsSaga } from './automations';
import { watchTemplateDateShiftSaga } from './date-shift';
import { watchGetDynamicTemplatePreviewSaga, watchUpdateDynamicTemplateConditionsSaga } from './dynamic-template';
import { watchFetchProjectTemplateSaga } from './fetch';
import { watchUpdateJiraMappingsInTemplateSaga } from './jira';
import { projectPhaseTemplateRootSaga } from './project-phase';
import { watchMilestoneRecognisedRevenueActionSaga } from './recognised-revenue';
import { // watchSaveProjectTemplateDraftSaga,
watchSaveProjectTemplateSaga, watchSaveProjectTemplateWithSheetTabDataSaga } from './save';
import { spaceTemplateRootSaga } from './space';
import { sprintTemplateRootSaga } from './sprint';
import { watchCreateSubTaskInTemplateSagaSaga } from './sub-task';
import { taskTemplateRootSaga } from './task';
export function* projectTemplateRootSaga() {
    yield all([
        fork(watchFetchProjectTemplateSaga),
        fork(watchSaveProjectTemplateSaga),
        fork(watchSaveProjectTemplateWithSheetTabDataSaga),
        fork(projectPhaseTemplateRootSaga),
        fork(taskTemplateRootSaga),
        fork(sprintTemplateRootSaga),
        fork(watchCreateSubTaskInTemplateSagaSaga),
        fork(spaceTemplateRootSaga),
        fork(watchUpdateJiraMappingsInTemplateSaga),
        fork(watchUpdateDynamicTemplateConditionsSaga),
        fork(watchGetDynamicTemplatePreviewSaga),
        fork(watchAllocationBulkActionSaga),
        fork(watchMilestoneRecognisedRevenueActionSaga),
        fork(watchUpdateAllocatedMemberSaga),
        fork(watchAllAutomationsSaga),
        spawn(watchTemplateDateShiftSaga)
    ]);
}
